import React, { useContext } from 'react';
import {FeatureFlagsContext} from "../../contexts/FeatureFlagsContext";

const featureFlagState = name => {
    const [featureFlagsState, ] = useContext(FeatureFlagsContext);

    return !!featureFlagsState.find(ff => ff.name === name && ff.enabled === true);
}

export { featureFlagState };